import PropTypes from "prop-types"
import React from "react"
import { useTranslation } from "react-i18next"
import NodeOrganization from "services/organizations/NodeOrganization"
import CumulativeBarChartTemplate from "views/molecules/charts/template/CumulativeBarChartTemplate"

const ChartODD13GHGEmissionsDistributionConsolidateMolecule = ({ score }) => {
  const { t } = useTranslation()

  const {
    datasets,
    label_keys,
    unit,
  } = score.odd13_emissions_breakdown_consolidated

  const data = datasets.map((dataset) => ({
    label: NodeOrganization.getNodeNameWithVersion(dataset.label_key),
    data: [...dataset.data],
  }))

  // Sorting is intentionally scoped to this component to guarantee
  // a descending category order for Chart 2 without impacting other charts
  // that also rely on CumulativeBarChartTemplate.
  const sortedCategoryIndexes = label_keys
    .map((_, index) => ({
      index,
      total: data.reduce((sum, dataset) => {
        const value = Number(dataset.data[index])

        if (!Number.isFinite(value)) {
          return sum
        }

        return sum + Math.max(value, 0)
      }, 0),
    }))
    .sort((a, b) => b.total - a.total)
    .map(({ index }) => index)

  const sortedLabelKeys = sortedCategoryIndexes.map(
    (categoryIndex) => label_keys[categoryIndex]
  )

  const datasetsSortedByCategory = data.map((dataset) => ({
    ...dataset,
    data: sortedCategoryIndexes.map(
      (categoryIndex) => dataset.data[categoryIndex] ?? 0
    ),
  }))

  const sortedData = datasetsSortedByCategory
    .slice()
    .sort((a, b) => (b.data[0] ?? 0) - (a.data[0] ?? 0))

  return (
    <CumulativeBarChartTemplate
      title={t(
        "score:score.13.chartGHGEmissionsDistributionConsolidated.title"
      )}
      datasets={sortedData}
      labelPath={"score:score.13.chartGHGEmissionsDistribution"}
      labelKeys={sortedLabelKeys}
      unitPath={"units:units.emission"}
      unitKey={unit}
      helpText={t(`score:score.13.chartGHGEmissionsDistribution.help`)}
      // Disable template-level sorting to preserve the order computed above.
      sortDatasets={false}
    />
  )
}

ChartODD13GHGEmissionsDistributionConsolidateMolecule.propTypes = {
  score: PropTypes.object,
}

export default ChartODD13GHGEmissionsDistributionConsolidateMolecule
